export default class LocalStorage {
  /**
   * Checks if the current browser has support for local storage via window.localStorage interface.
   *
   * @return {Boolean} Check result
   */
  get available() {
    try {
      const available = this.setItem(this.testKey, this.testKey).getItem(this.testKey).value === this.testKey;
      this.removeItem(this.testKey);
      return available;
    } catch (e) {
      return false;
    }
  }

  /**
   * Initiates a new instance of local storage class
   */
  constructor() {
    this.name = 'LocalStorageClass';
    this.testKey = 'acsam_lso_check';
  }

  /**
   * Overwrites the value of an item identified by a given key or creates a new item with the given key as identifier.
   *
   * @param {String} key - The key to identify the item in local storage
   * @param {*} value - The updated value
   * @return {LocalStorage} Current instance (allows chaining)
   */
  setItem(key, value) {
    window.localStorage.setItem(key, value);
    return this;
  }

  /**
   * Gets a stored item identified by a given key
   *
   * @param {String} key - The key of the stored item
   * @return {Object} The result, can be undefined when no item was found
   */
  // eslint-disable-next-line class-methods-use-this
  getItem(key) {
    return {
      key,
      // On some browsers null will be returned but we want a similarly functionality so we cast the result and return undefined when it's null
      value: window.localStorage.getItem(key) || undefined,
    };
  }

  /**
   * Removes a stored item identified by a given key
   *
   * @param {String} key - The key of the stored item
   */
  // eslint-disable-next-line class-methods-use-this
  removeItem(key) {
    window.localStorage.removeItem(key);
    return this;
  }
}
